// extracted by mini-css-extract-plugin
export var barContainer = "_32-0";
export var extraThin = "_32-3";
export var fillBar = "_32-6";
export var fillContainer = "_32-4";
export var overflow = "_32-8";
export var overflowContainer = "_32-5";
export var regular = "_32-7";
export var thick = "_32-1";
export var thin = "_32-2";